import { useTranslation } from "react-i18next";

export const useDropdownStyle = () => {
    const { i18n } = useTranslation();

    const DropStyle = {
        '& .MuiInputLabel-root': {
            left: i18n.language === 'ar' ? 'inherit' : '0px',
            right: i18n.language === 'ar' ? '30px' : 'inherit',
            transformOrigin: i18n.language === 'ar' ? 'right' : 'left'
        },
        '& .MuiOutlinedInput-root': {
            textAlign: i18n.language === 'ar' ? 'right' : 'left',
            '& .MuiSelect-icon': {
                right: i18n.language === 'ar' ? 'auto' : '7px',
                left: i18n.language === 'ar' ? '7px' : 'auto',
                position: 'absolute'
            }
        },
        '& .MuiOutlinedInput-notchedOutline': {
            textAlign: i18n.language === 'ar' ? 'right' : 'left'
        },
        '& legend': {
            textAlign: i18n.language === 'ar' ? 'right' : 'left',
        }
    }

    const inputStyle = {
        
            '& .MuiInputLabel-root': {
                  left: i18n.language === 'ar' ? 'inherit' : '0px',
                  right: i18n.language === 'ar' ? '30px' : 'inherit',
                  transformOrigin: i18n.language === 'ar' ? 'right' : 'left'
                },
                '& .MuiOutlinedInput-root': {
                  textAlign: i18n.language === 'ar' ? 'right' : 'left'
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  textAlign: i18n.language === 'ar' ? 'right' : 'left'
                },
                '& legend': {
                  textAlign: i18n.language === 'ar' ? 'right' : 'left'
                }
         
    }
    const iputType={
            style: { 
              textAlign: i18n.language === 'ar' ? 'right' : 'left',
              direction: 'ltr'  // Keep 'ltr' for phone numbers
            },
            // inputMode: 'tel',
            // pattern: '[0-9]*',
       
        }
        
    return { DropStyle, inputStyle, iputType };

}
